module.exports = __webpack_public_path__ + "static/media/landing_03.6e210d8c.svg";